import { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import { useOutsideClick } from '../hooks';
import NekoUI from '../NekoUI';

const NekoContextMenu = ({ children, visible, targetRef, onClose }) => {
  const portalRef = useRef();

  useOutsideClick(() => {
    if (visible) { onClose(); }
  }, [targetRef, portalRef]);

  useEffect(() => {
    const element = document.createElement('div');
    portalRef.current = element;
    return () => {
      portalRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (visible && portalRef.current && targetRef.current) {
      const rect = targetRef.current.getBoundingClientRect();
      portalRef.current.style.position = 'fixed';
      portalRef.current.style.top = `${rect.bottom}px`;
      portalRef.current.style.left = `${rect.left}px`;
      portalRef.current.style.width = `${rect.width}px`;
      portalRef.current.style.zIndex = 9999;
      document.body.appendChild(portalRef.current);
    } else {
      if (portalRef.current && portalRef.current.parentNode) {
        portalRef.current.parentNode.removeChild(portalRef.current);
      }
    }
  }, [visible, portalRef, targetRef]);

  useEffect(() => {
    const updatePosition = () => {
      if (visible && portalRef.current && targetRef.current) {
        const rect = targetRef.current.getBoundingClientRect();
        portalRef.current.style.position = 'fixed';
        portalRef.current.style.top = `${rect.bottom}px`;
        portalRef.current.style.left = `${rect.left}px`;
        portalRef.current.style.width = `${rect.width}px`;
        portalRef.current.style.zIndex = 9999;
      }
    };
    window.addEventListener('resize', updatePosition);
    window.addEventListener('scroll', updatePosition);

    return () => {
      window.removeEventListener('resize', updatePosition);
      window.removeEventListener('scroll', updatePosition);
    };
  }, [visible, portalRef, targetRef]);

  if (!visible || !portalRef.current) {
    return null;
  }

  return ReactDOM.createPortal(<NekoUI>{children}</NekoUI>, portalRef.current);
};

NekoContextMenu.propTypes = {
  children: PropTypes.node.isRequired,
  visible: PropTypes.bool,
  targetRef: PropTypes.object.isRequired,
  onClose: PropTypes.func,
};

NekoContextMenu.defaultProps = {
  visible: false,
  onClose: undefined,
};

export { NekoContextMenu };